import React from 'react';
import classNames from 'classnames';

const images = require.context('../../../Assets/emoji', true);

const Emoji = ({ setAnswer, value, options }) => {
  const renderEmoji = () => {
    // NOTE: Filter invalid emoji codes
    const filteredOptions = options.filter((option) => {
      const code = option.emoji_code && option.emoji_code.split('Emoji')[1];
      return code && +code >= 1 && +code <= 67;
    });
    return filteredOptions.map((option, i) => {
      const emoji = images(`./${option.emoji_code}.svg`);
      return (
        <li
          key={i}
          onClick={() => setAnswer(option.id)}
          className={classNames({
            active: value.toString() === option.id.toString(),
          })}
        >
          <img src={emoji} alt="emoji" />
        </li>
      );
    });
  };

  return (
    <div className="image-icon-wrap">
      <ul>{renderEmoji()}</ul>
    </div>
  );
};

export default Emoji;
